import { safeGetPos as e } from "../../utils/safe-get-pos.mjs";
import { useEffect as t, useState as n } from "react";
//#region src/extensions/list-extension/use-get-parent-count.ts
var r = ({ editor: r, getPos: i, nodeName: a }) => {
	let [o, s] = n(0);
	return t(() => {
		let t = (() => {
			let t = e(i);
			if (t === void 0) return 0;
			let n = 0, o = r.state.doc.resolve(t);
			for (let e = o.depth; e >= 0; e--) a ? o.node(e).type.name === a && n++ : n++;
			return n;
		})();
		o !== t && s(t);
	}, [
		r.state?.doc,
		i,
		a,
		o
	]), { realDepth: o };
};
//#endregion
export { r as useGetParentCount };
